// extracted by mini-css-extract-plugin
export default {"cls1":"ViP5Km5T_RDwbHFSfwtR","cls2":"Y7sAHvgUubLySL3BASPB ViP5Km5T_RDwbHFSfwtR"};